import { staffFeaturesPathMap } from "../../methods/featurePathMap.js";
import * as auth from "../actions/auth.js";
import jwtDecode from "jwt-decode";
// import Cookies from 'universal-cookie';
// const cookies = new Cookies();

const initialState = {
  isAuth: false,
  loading: false,
  otp: null,
  mfaEnabled: false,
  token: null,
  error: null,
  userType: null,
  appToken: null,
  email: null,
  inHomeApp: true,
  practices: [],
  firstName: null,
  lastName: null,
  fullName: null,
  phoneNumber: null,
  currentPractice: null,
  currentPracticeID: null,
  eCommerce: false,
  currentUserId: null,
  currentPG2UserId: null,
  goToPatientDasboard: false,
  enableECommerce: false,
  termsAgreed: false,
  rTermsAgreed: false,
  postLogin: false,
  showDobBanner: false,
  errorHTML: "",
  masterAdmin: false,
  region: [],
  country: null,
  isStaff: null,
  userPermissions: null,
  staffAllowedPaths: [],
  practitioner_id: null,
  gender: null,
  pure_account_details: {},
  dob: null,
  skin_color: null,
  userInfoTk: null,
  showSRPTable: false,
  ssoResponse: null, 
  ssoJwtToken: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case auth.AUTH_REQUEST: {
      return { ...state, loading: true, isAuth: false };
    }
    case auth.AUTH_SUCCESS: {
      if (action.payload.password_redirect_url) {
        return {
          ...state,
        };
      }
      const { practices, user_type, user } = jwtDecode(action.payload.token);
      return {
        ...state,
        error: false,
        isAuth: true,
        currentUserId: user.id,
        otp: action.payload.otp,
        mfaEnabled: false,
        email: user.email,
        postLogin: action.payload.post_login,
        firstName: user.first_name,
        lastName: user.last_name,
        fullName: user.full_name,
        phoneNumber: user.phone_number,
        loading: false,
        inHomeApp: true,
        token: action.payload.token,
        userType: user_type,
        enableECommerce: user.enable_ecommerce,
        currentPG2UserId: user.pg2_practitioner_id
          ? user.pg2_practitioner_id
          : user.pg2_patient_id,
        practices: Array.isArray(practices) ? practices : [practices],
        goToPatientDasboard:
          user_type === "Patient" ? user.welcome_shown : false,
        termsAgreed: Array.isArray(practices)
          ? practices[0]?.terms_agreed
          : practices?.terms_agreed,
        rTermsAgreed: Array.isArray(practices)
          ? practices[0]?.rialto_terms_agreed
          : practices?.rialto_terms_agreed,
        language: user.language,
        masterAdmin: user.master_admin,
        region: user.region || [],
        country: user.country,
        isStaff: user.is_staff,
        userPermissions: user.user_permissions,
        staffAllowedPaths: buildAllowedPaths(user?.is_staff, user?.user_permissions),
        practitioner_id: user.practitioner_id,
        userInfoTk: user.user_info_tk,
        showSRPTable: user.opt_for_search,
      };
    }
    case auth.FORGOT_EMAIL_SENT_SUCCESS: {
      return {
        ...state,
        inHomeApp: true,
        loading: false,
      };
    }
    case auth.AUTH_FAILURE: {
      console.log("in authfail", action.payload);
      return {
        ...state,
        error: action.error,
        errorHTML: "",
        inHomeApp: true,
        loading: false,
      };
    }
    case auth.LOGOUT_ST: {
      // localStorage.removeItem("persist:" + process.env.REACT_APP_STORE_KEY);
      return {
        ...state,
        isAuth: false,
        loading: false,
        mfaEnabled: false,
        token: null,
        userType: null,
        appToken: null,
        email: null,
        inHomeApp: true,
        practices: [],
        firstName: null,
        lastName: null,
        fullName: null,
        phoneNumber: null,
        // currentPractice: null,
        // currentPracticeID: null,
        currentPG2UserId: null,
        goToPatientDasboard: false,
        eCommerce: false,
        enableECommerce: false,
        currentUserId: null,
        postLogin: false,
        masterAdmin: false,
        country: null,
        termsAgreed: false,
        rTermsAgreed: false,
        showSRPTable: false,
        showDobBanner: false,
        userInfoTk: false,
        staffAllowedPaths: [],
      };
    }
    case auth.REFRESH_TOKEN_REQUEST: {
      return {
        ...state,
      };
    }
    case auth.REFRESH_TOKEN_SUCCESS: {
      return {
        ...state,
        token: action.payload.token,
      };
    }
    case auth.REFRESH_TOKEN_FAILURE: {
      return {
        ...state,
      };
    }
    case auth.CHANGE_IS_AUTH: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case auth.AGREED_TERMS_REQUEST: {
      return {
        ...state,
      };
    }
    case auth.TOGGLE_DOB_BANNER_STATE: {
      return {
        ...state,
        showDobBanner: !state.showDobBanner,
      };
    }
    case auth.AGREED_TERMS_SUCCESS: {
      return {
        ...state,
        termsAgreed: true,
      };
    }
    // SSO action handlers
    case auth.TRIGGER_SSO_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case auth.TRIGGER_SSO_SUCCESS: {
      console.log("in sso success reducer", action.payload);
      // payload can be a redirect URL string or an object containing a url field.
      const parseParamsFromUrl = (url) => {
        try {
          const fragment = (url || "").split("#")[1] || (url || "").split("?")[1] || "";
          if (!fragment) return {};
          return fragment.split("&").reduce((acc, part) => {
            const [k, v] = part.split("=");
            if (k) acc[k] = decodeURIComponent(v || "");
            return acc;
          }, {});
        } catch (e) {
          return {};
        }
      };

      let raw = action.payload;
      let parsed = {};

      if (typeof raw === "string") {
        parsed = parseParamsFromUrl(raw);
      } else if (raw && typeof raw === "object") {
        // some fetch responses may return an object with a `url` property
        if (typeof raw.url === "string") {
          parsed = parseParamsFromUrl(raw.url);
        } else {
          parsed = raw;
        }
      }

      return {
        ...state,
        loading: false,
        error: false,
        ssoResponse: {
          parsed, // e.g. { code: "...", id_token: "...", state: "..." }
          raw: action.payload,
        },
      };
    }
    case auth.TRIGGER_SSO_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload || true,
      };
    }
    case auth.EXCHANGE_TOKEN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case auth.EXCHANGE_TOKEN_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        ssoJwtToken: action.payload,
        // You might want to set other auth-related state here based on the token response
        isAuth: true,
        token: action.payload.access_token
      };
    }

    case auth.EXCHANGE_TOKEN_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        ssoJwtToken: null
      };
    }

    case "RELOAD_STATE": {
      const {
        token,
        user,
        practiceID,
        practices,
        practice,
        user_type,
        app_token,
        eCommerce,
        showDobBanner,
      } = action.payload;
      return {
        ...state,
        postLogin: false,
        mfaEnabled: true,
        isAuth: true,
        error: false,
        token: token,
        appToken: app_token,
        userType: user_type,
        inHomeApp: false,
        currentUserId: user?.id,
        email: user?.email,
        gender: user?.gender,
        dob: user?.dob,
        skin_color: user?.skin_color,
        firstName: user?.first_name,
        lastName: user?.last_name,
        fullName: user?.full_name,
        phoneNumber: user?.phoneNumber,
        practices: Array.isArray(practices) ? practices : [practices],
        currentPractice: practice,
        currentPracticeID: practiceID,
        eCommerce: user?.enable_ecommerce,
        enableECommerce: user?.enable_ecommerce,
        currentPG2UserId: user?.pg2_practitioner_id
          ? user?.pg2_practitioner_id
          : user?.pg2_patient_id,
        goToPatientDasboard:
          user_type === "Patient" ? user?.welcome_shown : false,
        termsAgreed: action.payload?.termsAgreed === "true",
        rTermsAgreed: Array.isArray(practices)
          ? practices[0]?.rialto_terms_agreed
          : practices?.rialto_terms_agreed,
        language: user?.language,
        masterAdmin: user?.master_admin,
        region: user?.region || [],
        country: user?.country,
        isStaff: user?.is_staff,
        userPermissions: user?.user_permissions,
        staffAllowedPaths: buildAllowedPaths(user?.is_staff, user?.user_permissions),
        practitioner_id: user?.practitioner_id,
        userInfoTk: user?.user_info_tk,
        showSRPTable: user.opt_for_search,
        showDobBanner,
      };
    }
    case "CLOSE_ERROR":
      return { ...state, error: {} };

    case auth.REG_PAN_REQUEST: {
      return {
        ...state,
      };
    }
    case auth.REG_PAN_SUCCESS: {
      return {
        ...state,
        pure_account_details: action.payload,
      };
    }
    case auth.REG_PAN_FAILURE: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

export default authReducer;


function buildAllowedPaths(isStaff = false, user_permissions = []) {
  console.log("Building allowed paths for staff:", typeof isStaff, typeof user_permissions, { isStaff, user_permissions });
  const set = [];
  if (isStaff) {
    user_permissions.forEach((item) => {
      const feature = Object.keys(item)[0];
      const scope = item[feature]; // read | create | manage

      // Expand scope → correct permission keys
      const keys = [];

      if (scope === "read") keys.push(`${feature}.read`);
      if (scope === "create") keys.push(`${feature}.create`);
      if (scope === "manage") {
        keys.push(`${feature}.read`);
        keys.push(`${feature}.create`);
        keys.push(`${feature}.manage`);
      }

      // Map permission keys → actual paths
      keys.flatMap(k => staffFeaturesPathMap[k] || []).forEach(path => set.push(path));
    });
    console.log("Allowed Paths Array:", set);
  }
  (staffFeaturesPathMap['default'] || []).forEach(path => set.push(path));
  return set;
}